import { useEffect } from 'react';
import './App.css';
import './i18n';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { EmpezarProvider } from './components/EmpezarModal';
import Home from './pages/Home';
import SellPhotos from './pages/SellPhotos';
import Pricing from './pages/Pricing';
import ServiceDetail from './pages/ServiceDetail';
import Brands from './pages/services/Brands';
import Corporate from './pages/services/Corporate';
import FanExperience from './pages/services/FanExperience';
import Sports from './pages/services/Sports';
import Hospitality from './pages/services/Hospitality';
import PhotographersOnDemand from './pages/services/PhotographersOnDemand';
import Productoras from './pages/services/Productoras';
import RequestDemo from './pages/RequestDemo';
import RequestPhotographers from './pages/RequestPhotographers';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';
import { NON_DEFAULT_CODES, getLangFromPath } from './i18n';
import { useTranslation } from 'react-i18next';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function LangSync() {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  useEffect(() => {
    const code = getLangFromPath(pathname);
    if (i18n.language !== code) i18n.changeLanguage(code);
    if (typeof document !== 'undefined') document.documentElement.lang = code;
  }, [pathname, i18n]);
  return null;
}

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/vende-tus-fotos" element={<SellPhotos />} />
    <Route path="/servicios/marcas" element={<Brands />} />
    <Route path="/servicios/eventos" element={<Corporate />} />
    <Route path="/servicios/fan-experience" element={<FanExperience />} />
    <Route path="/servicios/deportes" element={<Sports />} />
    <Route path="/servicios/hospitality" element={<Hospitality />} />
    <Route path="/servicios/fotografos-on-demand" element={<PhotographersOnDemand />} />
    <Route path="/servicios/productoras" element={<Productoras />} />
    <Route path="/servicios/:slug" element={<ServiceDetail />} />
    <Route path="/precios" element={<Pricing />} />
    <Route path="/request-demo" element={<RequestDemo />} />
    <Route path="/solicitar-fotografos" element={<RequestPhotographers />} />
  </Routes>
);

function App() {
  return (
    <HelmetProvider>
      <div className="App dark">
        <BrowserRouter>
          <EmpezarProvider>
            <ScrollToTop />
            <LangSync />
            <Navbar />
            <main>
              <Routes>
                {NON_DEFAULT_CODES.map((code) => (
                  <Route key={code} path={`/${code}/*`} element={<AppRoutes />} />
                ))}
                <Route path="/*" element={<AppRoutes />} />
              </Routes>
            </main>
            <Footer />
          </EmpezarProvider>
        </BrowserRouter>
        <Toaster />
      </div>
    </HelmetProvider>
  );
}

export default App;
